<template>
  <template v-for="(item, index) in items" :key="index">
    <component :is="item.component" v-bind="item.props" />
  </template>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import {
  type ArticleComponentNameAndProps,
  getComponentNameAndProps,
  type PreloadedData,
} from './lib/articleComponents';
import { type ArticleContent } from './models/ArticleContent';

interface Props {
  content: ArticleContent;
  preloadedData?: PreloadedData;
}

const props = defineProps<Props>();

const items = computed(() => {
  const preparedItems: ArticleComponentNameAndProps[] = [];

  for (let contentIndex = 0; contentIndex < props.content.length; ++contentIndex) {
    const item = props.content[contentIndex];
    if (!item) {
      continue;
    }
    const preparedItem = getComponentNameAndProps(item, props.preloadedData);

    if (preparedItem) {
      preparedItems.push(preparedItem);
    }
  }

  return preparedItems;
});
</script>
